<template>
    <div>
        <div class="w-full flex flex-row justify-between py-4 border-b border-gray-300">
            {{ $t('plain_abonnements') }}
            <span @click="administerAbonnement = !administerAbonnement" class="text-blue text-xxs self-end cursor-pointer">
                {{ $t('administer_abonnements') }}
            </span>
        </div>
        <span @click="redirect('ch')" v-if="getGlobalAbonnementAmount() && getRegion() === 'de'" class="text-blue text-xxs cursor-pointer">
            {{ $t('You have') }} {{ getGlobalAbonnementAmount() }} {{ $t('plain_global') }} {{ $t('plain_abonnements') }} - {{ $t('click here to switch') }}
        </span>
        <div class="my-8">
            <Loading :loading="loading" preserveHeight="true">
                <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8" v-if="!loading">
                    <SingleAbonnement
                        @reload="indexAbonnements()"
                        v-for="abonnement in getByKey('index').data"
                        :key="abonnement.id"
                        :abonnement="abonnement"
                        :hasPaymentMethod="hasPaymentMethodCache"
                        @upgradeAbonnement="upgradeAbonnement($event)"
                        @upgradeToParentAbonnement="upgradeToParentAbonnement($event)"
                        @bookWebinar="bookWebinar($event)"
                        @paymentMethodClicked="changePaymentMethod(abonnement)"
                        @extendAbonnement="extendAbonnement($event)"
                    />
                    <div
                        class="bg-blue-dark text-white rounded-md shadow-md p-4 relative min-h-[285px] flex flex-col gap-4 justify-center items-center cursor-pointer"
                        @click="$router.push('/produkte')"
                    >
                        <div class="w-24 h-24 rounded-full bg-blue flex justify-center items-center">
                            <Icon type="Plus" width="48" height="47" viewBox="0 0 48 47" />
                        </div>
                        <p>
                            {{ $t('add_abonnement') }}
                        </p>
                    </div>
                </div>
                <Pagination :limit="3" :data="getByKey('index')" @pagination-change-page="paginate" />
            </Loading>
        </div>

        <UpgradeAbonnementModal v-if="upgradeAbonnementPopupOpen" v-model:open="upgradeAbonnementPopupOpen" v-model:abonnementId="selectedAbonnement.id" />
        <UpgradeToParentAbonnementModal v-if="upgradeToParentAbonnementPopupOpen" v-model:open="upgradeToParentAbonnementPopupOpen" v-model:abonnementId="selectedAbonnement.id" />
        <BookWebinarModal v-if="bookWebinarPopupOpen && !global" v-model:open="bookWebinarPopupOpen" v-model:abonnement="selectedAbonnement" />
        <AdministerAbonnementModal v-if="administerAbonnement" v-model:open="administerAbonnement" />
        <ChangePaymentMethodModal v-if="changePaymentMethodModalOpen" v-model:open="changePaymentMethodModalOpen" :abonnement="selectedAbonnement" @reload="indexAbonnements()" />
        <ExtendAbonnementModal v-if="extendAbonnementModalOpen" v-model:open="extendAbonnementModalOpen" :abonnement="selectedAbonnement" @reload="indexAbonnements()" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { getRegion } from '../../helpers.js';

export default {
    data: () => ({
        selectedItems: [],
        isAllSelected: false,
        loading: false,
        upgradeAbonnementPopupOpen: false,
        upgradeToParentAbonnementPopupOpen: false,
        bookWebinarPopupOpen: false,
        administerAbonnement: false,
        selectedAbonnement: null,
        currentPage: null,
        changePaymentMethodModalOpen: false,
        extendAbonnementModalOpen: false,
        urls: {
            de: 'www.hkcmanagement.de',
            ch: 'www.hkcmglobal.com'
        },
        hasPaymentMethodCache: true
    }),

    methods: {
        getRegion,
        paginate(page = 1) {
            this.currentPage = page;
            this.indexAbonnements({
                page: page
            });
        },
        async indexAbonnements(params) {
            this.loading = true;
            let config = {
                params: {
                    'sort[by]': 'created_at',
                    per_page: 100,
                    key: 'index',
                    webinar: false,
                    current: true
                }
            };

            _.merge(config.params, params);

            this.hasPaymentMethod();

            return await this.$store.dispatch('abonnements/index', config).then(() => {
                this.loading = false;
            });
        },
        upgradeAbonnement(abonnement) {
            this.upgradeAbonnementPopupOpen = true;
            this.selectedAbonnement = abonnement;
        },
        upgradeToParentAbonnement(abonnement) {
            this.upgradeToParentAbonnementPopupOpen = true;
            this.selectedAbonnement = abonnement;
        },
        bookWebinar(abonnement) {
            this.bookWebinarPopupOpen = true;
            this.selectedAbonnement = abonnement;
        },
        changePaymentMethod(abonnement) {
            this.changePaymentMethodModalOpen = true;
            this.selectedAbonnement = abonnement;
        },
        getGlobalAbonnementAmount() {
            return this.getByKey('index').data?.filter((abonnement) => abonnement.region === 'ch').length || 0;
        },
        redirect(targetRegion) {
            window.location.href = `https://${this.urls[targetRegion]}`;
        },
        extendAbonnement(abonnement) {
            this.extendAbonnementModalOpen = true;
            this.selectedAbonnement = abonnement;
        },
        hasPaymentMethod() {
            if (this.$store.getters['payment_methods/get'].data?.length) {
                this.hasPaymentMethodCache = true;
            }

            this.$store.dispatch('payment_methods/index').then((paymentMethods) => {
                this.hasPaymentMethodCache = paymentMethods.data.length > 0;
            });
        }
    },

    computed: {
        ...mapGetters('abonnements', ['getByKey']),
        global() {
            return window.meta.region_configuration.region !== 'de';
        }
    },

    mounted() {
        this.indexAbonnements();
    }
};
</script>
